import { defaultLineSpacing, LineSpacing, lineSpacings } from '../types/line.spacing';

function validateLineSpacing(value: string | null | undefined): LineSpacing {
    return lineSpacings.includes(value as LineSpacing) ? (value as LineSpacing) : defaultLineSpacing;
}

export { validateLineSpacing };
